import type { RiskInsightsSiteRow } from 'src/app/portfolio/state/api/riskInsightsSitesQuery';
import type { RiskDynamicsSite } from 'src/shared/components/charts/risk-dynamics-scatter-chart/RiskDynamicsScatterChart';

export function toChartSites(rows: RiskInsightsSiteRow[]): RiskDynamicsSite[] {
    return rows.flatMap(row => {
        const deps = row.riskSummary?.operationalDependencies;
        const impact = row.riskSummary?.impactsOnNature;
        if (deps === null || deps === undefined || impact === null || impact === undefined) return [];
        return [
            {
                id: row.id,
                name: row.name,
                dependencies: deps,
                impactOnNature: impact,
                physicalRisk: row.riskSummary?.physicalNatureRisk ?? null,
                stateOfNature: row.riskSummary?.stateOfNature ?? null,
            },
        ];
    });
}
